import { SvgCamiseta, SvgEscudo } from '@/types/editProfile';

export function enforceMinBrightness(hex: string): string {
  // Limpiar el hex y asegurar formato correcto
  const cleanHex = hex.replace('#', '');

  // Convertir hex a RGB
  const r = parseInt(cleanHex.slice(0, 2), 16);
  const g = parseInt(cleanHex.slice(2, 4), 16);
  const b = parseInt(cleanHex.slice(4, 6), 16);

  // Verificar si es un color gris/negro (R ≈ G ≈ B)
  // Permitimos una pequeña tolerancia para variaciones mínimas
  const tolerance = 5;
  const isGrayish =
    Math.abs(r - g) <= tolerance &&
    Math.abs(g - b) <= tolerance &&
    Math.abs(r - b) <= tolerance;

  // Si NO es un color gris/negro, devolver el color original
  if (!isGrayish) {
    return hex;
  }

  // Si ES gris/negro, verificar si es más oscuro que #323232 (50, 50, 50)
  const minValue = 50; // #323232 = rgb(50, 50, 50)
  const avgValue = (r + g + b) / 3;

  // Si es más oscuro que #323232, devolver #323232
  // Si es más claro que #323232, devolver el color original
  return avgValue < minValue ? '323232' : hex;
}

export function parseParamsTshirtAndShield<
  T extends Record<string, string | undefined>
>(value: string | undefined, keys: (keyof T)[], fallback: T): T {
  const values = value?.split(',') ?? [];
  return keys.reduce(
    (acc, key, index) => {
      acc[key] = (values[index] ?? fallback[key]) as T[keyof T];
      return acc;
    },
    { ...fallback }
  );
}
// Definimos las keys
export const tshirtKeys: (keyof SvgCamiseta)[] = [
  'param1',
  'param2',
  'param3',
  'param4',
  'param5',
];

export const shieldKeys: (keyof SvgEscudo)[] = [
  'escudoparam1',
  'escudoparam2',
  'escudoparam3',
  'escudoparam4',
  'escudoparam5',
];
